import { render, staticRenderFns } from "./exhibition-info-invoiceAlterEdit.vue?vue&type=template&id=20b34748&scoped=true&"
import script from "./exhibition-info-invoiceAlterEdit.vue?vue&type=script&lang=js&"
export * from "./exhibition-info-invoiceAlterEdit.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-info-invoiceAlterEdit.vue?vue&type=style&index=0&id=20b34748&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b34748",
  null
  
)

export default component.exports